// src/json/overlayData.json
export const overlaySectionCommercialExteriorPainting = {
    imageUrl: "/assets/imgs/services/3CommercialExteriorPainting/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
